import { ATTACHED_IMAGE, attachedImageLine } from '@k2/agents/chat/image'
import type { Component } from 'vue'

// `id` names what the chip is about, so the page can mark it until the message goes.
export type ChatChip = { readonly id?: string; readonly label: string; readonly icon?: Component; readonly placeholder?: string }

// A message about one thing starts with it in brackets, "[Faza · Slide 3] …": the model reads it there, the bubble shows a chip.
const CHIP = /^\[([^\]\n]{1,80})\]\s+/

export const withChip = (chip: ChatChip | null, text: string) => (chip ? `[${chip.label}] ${text}` : text)

export const chipOf = (text: string) => {
  const match = CHIP.exec(text)
  return match?.[1] ? { label: match[1], rest: text.slice(match[0].length) } : null
}

// A picture the user attached rides at the end of the message, one line each: the model reads its id, the bubble a chip.
export type ChatPicture = { readonly id: string; readonly label: string }

export const withAttachments = (text: string, attachments: readonly ChatPicture[]) =>
  attachments.length
    ? [text.trim(), ...attachments.map(attachment => attachedImageLine(attachment.id, attachment.label))].filter(Boolean).join('\n')
    : text

export const attachmentsOf = (text: string) => {
  const lines = text.split('\n')
  const attachments: ChatPicture[] = []
  while (lines.length) {
    const match = ATTACHED_IMAGE.exec(lines.at(-1) ?? '')
    if (!match?.[1]) break
    attachments.unshift({ id: match[1], label: match[2] ?? '' })
    lines.pop()
  }
  return { text: lines.join('\n').trim(), attachments }
}
